import { Injectable } from "@angular/core";
import { ConditionListsAgreementModel } from "../../models/components/condition-lists-agreement.model";
import { ProductPopUpBaseService } from "./product-pop-up-base.service";

@Injectable({
    providedIn: "root"
})
export class ConditionListsPopUpService extends ProductPopUpBaseService<ConditionListsAgreementModel> {
}
